import { Card, Group, Stack, Text } from "@/components/ui";
import { formatFechaHora } from "@/shared/format/fecha";
import type { HistorialAutorizacionesStats } from "../services/historial-service";

/**
 * Resumen de KPIs sobre el historial · totales, % autorizada-completa,
 * última firma. Da contexto antes de la tabla. Los números vienen del
 * SERVER calculados sobre el set filtrado completo (el listado pagina ·
 * la página visible no alcanza para estos conteos).
 */
export function HistorialResumenCard({
  total,
  stats,
}: {
  total: number;
  stats: HistorialAutorizacionesStats | undefined;
}) {
  const completadas = stats?.completadas ?? 0;
  const ultima = stats?.ultimaAutorizacion
    ? formatFechaHora(stats.ultimaAutorizacion)
    : "—";

  return (
    <Card padding="md">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Stat label="Total de firmas" value={String(total)} />
        <Stat
          label="Llegaron a autorización completa"
          value={
            total > 0
              ? `${completadas} (${Math.round((completadas / total) * 100)}%)`
              : "—"
          }
        />
        <Stat label="Última autorización" value={ultima} />
      </div>
    </Card>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <Stack gap={4}>
      <Text size="xs" c="dimmed" fw={500} tt="uppercase" className="tracking-wide">
        {label}
      </Text>
      <Group gap={6} align="baseline">
        <Text fw={700} size="lg">
          {value}
        </Text>
      </Group>
    </Stack>
  );
}
